import React from 'react';
// import { Link } from 'react-router-dom';
import links from 'utils/links';

import PropTypes from 'prop-types';
import classNames from 'classnames';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import BookmarkIcon from '@material-ui/icons/BookmarkBorder';
import InfoIcon from '@material-ui/icons/Info';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ShareIcon from '@material-ui/icons/Share';
import { withStyles } from '@material-ui/core/styles';
import ShareOptions from './ShareOptions';
import ClearIcon from '@material-ui/icons/Clear';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

const styles = theme => ({
  cardContainer: {
    height: '100%',
    position: 'relative',
  },
  cardContent: {
    paddingBottom: '60px',
  },
  actions: {
    marginTop: '20px',
    position: 'absolute',
    width: '100%',
    bottom: '0',
    backgroundColor: theme.palette.primary.main,
    height: '40px',
  },
  infoIcon: {
    color: theme.palette.secondary.main,
    fontSize: '0.5em',
  },
  actionIcon: {
    backgroundColor: theme.palette.secondary.main,
    color: 'white',
    margin: '5px',
    marginTop: '-30px',
    boxShadow: '1px 1px grey',
    '&:hover': {
      '@media': {
        backgroundColor: '#391b16',
      },
      '&:focus': {
        backgroundColor: 'grey',
      },
    },
  },

  actionButton: {
    position: 'absolute',
    left: -theme.spacing.unit * 3 - 4,
    top: 30,
    paddingLeft: theme.spacing.unit * 5,
    textTransform: 'none',
  },
  media: {
    height: 180,
    position: 'relative',
    width: '100%',
    marginTop: '-10px',
  },
  inline: {
    // display: 'inline',
    fontSize: '0.75rem',
    fontWeight: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    lineHeight: '16px' /* fallback */,
    maxHeight: '32px' /* fallback */,
    WebkitLineClamp: 1 /* number of lines to show */,
    WebkitBoxOrient: 'vertical',
  },
  pushRight: {
    marginLeft: 'auto',
  },
  storyTitle: {
    justifyContent: 'space-between',
    fontSize: '1.125rem',
    fontWeight: 'medium',
    fontFamily: 'Catamaran, Roboto, Helvetica, Arial, sans-serif',
    // overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    maxHeight: '26px' /* fallback */,
    lineHeight: 1,
    WebkitLineClamp: 2 /* number of lines to show */,
    WebkitBoxOrient: 'vertical',
  },
  descStyle: {
    fontFamily: 'Catamaran, Roboto, Helvetica, Arial, sans-serif',
    fontSize: '15px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    // lineHeight: '16px' /* fallback */,
    maxHeight: '32px' /* fallback */,
    WebkitLineClamp: 1 /* number of lines to show */,
    WebkitBoxOrient: 'vertical',
  },
});

class RnFArticle extends React.Component {
  state = {
    open: false,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  render() {
    let {
      classes,
      name,
      // curatedBy,
      img,
      // summary,
      location,
      removable,
      id,
      data,
      desc,
    } = this.props;
    removable = removable ? removable : false;
    if (!name) {
      return <span />;
    }
    const checkDataHasCity = data ? data.city : '';
    data.city = checkDataHasCity ? checkDataHasCity : '';
    const linkTitleCheck = data ? data.linkTitle : '';
    const linksTi = linkTitleCheck ? linkTitleCheck : '';
    // let storyLink = links.story(data.linkTitle);
    let storyLink = links.story(linksTi);
    const locationCheck = location ? location : 0;
    // const lineLength = name.split(/\r\n|\r|\n/).length;
    // console.log(lineLength);

    // const checkLocationHasLati = locationCheck ? locationCheck.longitude : 0;
    // const checkLocationHasLongi = locationCheck ? locationCheck.longitude : 0;
    // const lati = checkLocationHasLati.latitude
    //   ? checkLocationHasLati.latitude
    //   : 0;
    // const longi = checkLocationHasLongi.longitude
    //   ? checkLocationHasLongi.longitude
    //   : 0;

    return (
      <Card className={classes.cardContainer}>
        <CardHeader
          title={
            <div className={classes.storyTitle}>
              <a href={storyLink}>{name}</a>
              {removable ? (
                <ClearIcon
                  className={classes.icon}
                  onClick={() => this.props.onRemove(id)}
                />
              ) : null}
            </div>
          }
          subheader={
            <div>
              <Typography
                variant="subtitle2"
                classes={{ root: classes.inline }}
              >
                {/* Curated by {curatedBy} */}
              </Typography>
            </div>
          }
        />
        {/* <Link to={storyLink}>
          <CardMedia
            className={classNames(classes.media)}
            image={img ? img : '/img/na.png'}
          />
        </Link> */}
        <br />
        <br />
        <a href={storyLink}>
          <CardMedia
            className={classNames(classes.media)}
            image={img ? img : '/img/na.png'}
          />
        </a>
        <CardContent className={classes.cardContent}>
          {/* <Typography variant="body1">
            &#x201C;
            {summary}
            &#x201D;
          </Typography> */}
          {/* <Typography align="right" variant="body2">
            …read more
          </Typography> */}
          <i className={classes.descStyle}>{desc}</i>
        </CardContent>
        <CardActions className={classes.actions} disableActionSpacing>
          <IconButton className={classes.infoIcon} aria-label="Information">
            <InfoIcon />
          </IconButton>
          <div className={classes.pushRight}>
            {localStorage.getItem('tsUserInfo') ? (
              <IconButton
                className={classes.actionIcon}
                color="secondary"
                aria-label="Bookmark"
              >
                <BookmarkIcon />
              </IconButton>
            ) : (
              <React.Fragment>
                <IconButton
                  className={classes.actionIcon}
                  color="secondary"
                  aria-label="Bookmark"
                  onClick={this.handleClickOpen}
                >
                  <BookmarkIcon />
                </IconButton>
                <Dialog
                  open={this.state.open}
                  onClose={this.handleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="alert-dialog-title">
                    {'Talking Street '}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      Please Sign-in or Sign-up to proceed/Bookmark
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={this.handleClose}
                      color="primary"
                      autoFocus
                    >
                      Ok
                    </Button>
                  </DialogActions>
                </Dialog>
              </React.Fragment>
            )}
            <ShareOptions
              shareUrl={window.location.origin + storyLink}
              shareTitle={'Talking Street : ' + name}
              shareButton={
                <IconButton className={classes.actionIcon} aria-label="Share">
                  <ShareIcon />
                </IconButton>
              }
            />
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={links.map(locationCheck.latitude, locationCheck.longitude)}
            >
              <IconButton className={classes.actionIcon} aria-label="Location">
                <LocationOnIcon />
              </IconButton>
            </a>
          </div>
        </CardActions>
      </Card>
    );
  }
}

RnFArticle.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RnFArticle);
